import { ColumnDef } from '@tanstack/react-table';

import { DataTableExpandableRows } from './data-table-expandable-rows';
import { ScrollArea, ScrollBar } from '@/components/ui/scroll-area';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';

interface Props<TData, TValue> {
  columns: ColumnDef<TData, TValue>[];
  columnLabels: string[];
  data: Record<string, TData[]>;
  onRowClick?: (item: TData) => void;
  success: boolean;
}

export function DataTableGrouped<TData, TValue>({
  columns,
  columnLabels,
  data,
  onRowClick,
  success,
}: Props<TData, TValue>) {
  return (
    <ScrollArea className="h-[70vh] rounded-md border">
      <Table>
        <TableHeader className="bg-background sticky top-0 z-50">
          <TableRow className="hover:bg-background">
            {columnLabels.map((col) => (
              <TableHead key={col}>{col}</TableHead>
            ))}
          </TableRow>
        </TableHeader>
        {Object.entries(data).map(([group, items]) => (
          <DataTableExpandableRows
            key={group}
            columns={columns}
            data={items}
            label={group}
            onRowClick={onRowClick}
          />
        ))}
        <TableBody>
          {success && Object.keys(data).length === 0 && (
            <TableRow>
              <TableCell
                colSpan={columnLabels.length}
                className="h-24 text-center"
              >
                No results
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      <ScrollBar orientation="horizontal" />
      <ScrollBar orientation="vertical" />
    </ScrollArea>
  );
}
